import { configureStore } from "@reduxjs/toolkit";
import opinionTradingSlice from "./slices/opinionTradingSlice";
import predictionSlice from "./slices/predictionSlice";
import inPlaySlice from "./slices/inPlaySlice";

export const store = configureStore({
    reducer: {
        prediction: predictionSlice,
        opinionTrading:opinionTradingSlice,
        inPlaySlice:inPlaySlice
    }
})